
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/d/new-music/all",
      function () {
        return require("private-next-pages/d/new-music/all/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/d/new-music/all"])
      });
    }
  